import { Sparkle } from '@phosphor-icons/react';
import type { FC } from 'react';
import useQuickHelpContext from '@providers/QuickHelp/useQuickHelpContext';
import useApp from '@providers/App/useApp';
import styles from './AskAiButton.module.css';

/** Shown only when the panel is closed. Disappears once the panel opens — the
 *  panel header's own collapse arrow takes over as the close control. */
const AskAiButton: FC = () => {
    const { state, actions } = useQuickHelpContext();
    const { currentUser } = useApp();

    if (currentUser?.role === 'CONSULTANT') return null;
    if (state.isOpen) return null;

    return (
        <button
            type="button"
            className={styles.button}
            onClick={actions.togglePanel}
            aria-label="Open AI assistant"
        >
            <span className={styles.shimmer} aria-hidden />
            <span className={styles.icon}>
                <Sparkle size={15} weight="duotone" />
            </span>
            Ask AI
        </button>
    );
};

export default AskAiButton;
